import axios from "axios";

const GetBrowserDetail = async () => {
  const userAgent =
    typeof window !== "undefined" && window.navigator
      ? window.navigator.userAgent
      : "Browser Details N/A";
  return userAgent;
};

const GetIp = async () => {
  try {
    const proIp = await axios.get(
      `https://pro.ip-api.com/json/?key=CihzNa1Xn4Mz2oJ`
    );
    if (proIp) {
      return proIp?.data?.query;
    }
    return "";
  } catch (err) {
    console.log("err fetching IP: ", err);
    return "";
  }
};

export const payloadSetter = async (auth, betPlacing) => {
  const browserdetail = await GetBrowserDetail();
  const ip = await GetIp();

  if (betPlacing.marketType == "SESSION") {
    let newRate;
    if (betPlacing.fancyPrice === 0) {
      newRate = 1;
    } else {
      newRate = betPlacing.fancyPrice / 100;
    }

    const payload = {
      token: auth,
      bet: {
        runnerId: 1,
        selectionName: betPlacing.priceActual,
        rate: parseFloat(newRate),
        stake: parseFloat(betPlacing.stake),
        marketId: betPlacing.market,
        marketName: betPlacing.marketName,
        marketType: "SESSION",
        eventId: betPlacing.eventId,
        eventName: betPlacing.eventName,
        type: betPlacing.isBack ? "Back" : "Lay",
        browserdetail: browserdetail,
        ipaddress: ip,
      },
    };

    return payload;
  } else {
    const payload = {
      token: auth,
      bet: {
        runnerId: betPlacing.runner,
        selectionName: betPlacing.runnerName,
        rate: parseFloat(betPlacing.priceActual),
        stake: parseFloat(betPlacing.stake),
        marketId: betPlacing.market,
        marketName: betPlacing.marketName,
        marketType: betPlacing.marketType,
        eventId: betPlacing.eventId,
        eventName: betPlacing.eventName,
        type: betPlacing.isBack ? "Back" : "Lay",
        browserdetail: browserdetail,
        ipaddress: ip,
      },
    };

    return payload;
  }
};

export function storeUserData(userId, newData) {
  // Get existing data from localStorage
  const existingData = JSON.parse(localStorage.getItem(userId)) || [];

  // Normalize newData to an array
  const newEntries = Array.isArray(newData) ? newData : [newData];
  // Filter out duplicates based on gameId and tableId
  const filteredEntries = newEntries.filter((newEntry) => {
    return !existingData.some(
      (existingEntry) =>
        existingEntry.gameId === newEntry.gameId &&
        existingEntry.tableId === newEntry.tableId
    );
  });
  // If no new data to add, exit early
  if (filteredEntries.length === 0) return;

  // Merge existing data with filtered new data
  let updatedData = [...existingData, ...filteredEntries];

  // Enforce maximum of 24 objects
  if (updatedData.length > 24) {
    updatedData = updatedData.slice(updatedData.length - 24); // Keep last 24 items
  }

  // Save updated array back to localStorage
  localStorage.setItem(userId, JSON.stringify(updatedData));
}
